module.exports =  {
    baseUrl: window.location.origin+'/api',
    examServerUrl: window.location.origin+'/api',
    analyticsConstantData: {
        	StreamName:"exam_analytics_data_collector",
	        PartitionKey: "key"
        }
}